import tenantConstants from '@constants';
import tenantRoutes from '@routes';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Button, Icon, Popover, TextInput } from '../../../../components/common';
import NotificationCentre from '../../../../components/notification-center/notification-center';
import { useGetLocation, useRouteNavigate } from '../../../../hooks';
import { addPropertyEvent, downloadAppButtonClick } from '../../../../services/analyticsService';
import DownloadAppModal from '../downloadAppModal/downloadAppModal';
import HeaderLink from '../headerLink/headerLink';
import { AtbdTopDropdwon } from './style';
import { getLocaleForURL } from '../../../../utility/language';
import PostListingMenu, {
  POST_LISTING_MENU_PLACEMENTS,
  PostListingHeaderScrim,
  PostListingMenuScrim,
  usePostListingMenu,
} from '../../../../components/post-listing-menu/post-listing-menu';
import { TriggerWrap } from '../../../../components/post-listing-menu/styled';

const HeaderComponent = () => {
  const { t } = useTranslation();
  const rtl = useSelector((state) => state.app.AppConfig.rtl);
  const user = useSelector((state) => state.app.loginUser.user);
  const { pathname: path } = useGetLocation();
  const currentPathSlug = path.split('/').pop();
  const navigate = useRouteNavigate();
  const [value, setValue] = useState('');
  const isMobile = useSelector((state) => state.app.AppConfig.isMobile);
  const [modal, setModal] = useState(false);
  const postListingMenu = usePostListingMenu(POST_LISTING_MENU_PLACEMENTS.TOP_NAV);
  const enablePostListingMenu = tenantConstants.ENABLE_POST_LISTING_REVAMP && !isMobile;

  const onSearch = () => {
    navigate(`${tenantRoutes.app().listings.path}?q[listing_id_eq]=${value}`);
  };

  const content = (
    <AtbdTopDropdwon
      className="search-widget grid align-items-center"
      style={{ '--template': 'auto auto', gap: '10px' }}
    >
      <TextInput
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={t('Search By ID')}
        prefixIcon="BiSearch"
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            onSearch(e.target.value);
          }
        }}
        autoFocus
      />
      <Button type="primary" size="large" onClick={onSearch} style={{ height: '40px' }}>
        {t('Search')}
      </Button>
    </AtbdTopDropdwon>
  );

  const renderNotificationCenter = () => {
    return (
      tenantConstants.NOTIFICATION_CENTER_ENABLED &&
      user?.push_notifications?.value == 'enabled' && <NotificationCentre />
    );
  };

  return (
    <>
      {enablePostListingMenu && (
        <>
          <PostListingMenuScrim />
          <PostListingHeaderScrim />
        </>
      )}
      {!isMobile ? (
        <>
          {tenantConstants.PITCH_MOBILE_APP && (
            <>
              <Button
                className="px-0"
                type="link"
                icon="MdPhoneIphone"
                iconSize="1.3em"
                onClick={() => {
                  setModal(true);
                  downloadAppButtonClick(user);
                }}
              >
                {t('Download App')}
              </Button>
              <DownloadAppModal visible={modal} onClose={() => setModal(false)} />
            </>
          )}
          <HeaderLink variant="headerPill" />

          {enablePostListingMenu ? (
            <TriggerWrap
              ref={postListingMenu.triggerRef}
              onMouseEnter={() => postListingMenu.openMenu()}
              onMouseLeave={postListingMenu.scheduleClose}
            >
              <Button
                type="primary"
                icon="PostListingIcon"
                onClick={postListingMenu.toggleMenu}
                onKeyDown={postListingMenu.onTriggerKeyDown}
                {...postListingMenu.triggerAriaProps}
              >
                {t('Post a Listing')}
                <Icon icon="FiChevronDown" size="1em" style={{ marginInlineStart: '-2px' }} />
              </Button>
              <PostListingMenu
                placement={POST_LISTING_MENU_PLACEMENTS.TOP_NAV}
                open={postListingMenu.open}
                focusFirstRow={postListingMenu.focusFirstRow}
                panelRef={postListingMenu.panelRef}
                onClose={postListingMenu.closeMenu}
                onMouseEnter={postListingMenu.cancelScheduledClose}
                onMouseLeave={postListingMenu.scheduleClose}
              />
            </TriggerWrap>
          ) : (
            <Button
              type="primary"
              icon="PostListingIcon"
              onClick={() => {
                window.location.href = `${getLocaleForURL()}${tenantRoutes.app('', false, user).post_listing.path}`;
                addPropertyEvent(user, currentPathSlug, false);
              }}
            >
              {t('Post Listing')}
            </Button>
          )}
          {renderNotificationCenter()}
        </>
      ) : (
        renderNotificationCenter()
      )}
      {tenantConstants.SHOW_SEARCH_HEADER && (
        <>
          <Popover placement={rtl ? 'bottomLeft' : 'bottomRight'} content={content} action="click">
            <Button type="default" style={{ paddingInline: '.65em', alignSelf: 'stretch' }}>
              <Icon icon="BiSearch" />
            </Button>
          </Popover>
        </>
      )}
    </>
  );
};

export default HeaderComponent;
